/**
 * Pure planners for filter side panels. Kept free of React so they can be unit-tested under
 * vitest's `environment: 'node'` — the same split the exploration module already uses for
 * `explorationUrlSyncPlan.ts`.
 */

/**
 * Pending filter state is re-seeded from the applied filters only on the closed→open edge,
 * never while the user is editing an open panel.
 */
export function shouldSyncPendingOnOpenEdge(open: boolean, lastSyncedOpen: boolean): boolean {
  return open && !lastSyncedOpen;
}

/**
 * Force-open the sections named by `shouldOpen`, leaving every other section's current state
 * alone. Sections are never force-*closed* by this pass.
 */
export function planDisclosureInit<K extends string>(
  current: Record<K, boolean>,
  shouldOpen: Partial<Record<K, boolean>>
): Record<K, boolean> {
  let changed = false;
  const next = { ...current };
  (Object.keys(shouldOpen) as K[]).forEach((key) => {
    if (shouldOpen[key] && !next[key]) {
      next[key] = true;
      changed = true;
    }
  });
  return changed ? next : current;
}
